/** Canada RE amenity/feature presets for listing-file Feature tags.
 * Keep in sync with Bricks-Dispatch web/src/lib/amenityPresets.ts.
 * Chips only fill the label field — never auto-add onto the tour.
 */
export const AMENITY_PRESETS = [
  "Chef's kitchen",
  'Kitchen island',
  'Quartz counters',
  'Stainless appliances',
  'Walk-in closet',
  'Ensuite',
  'Soaker tub',
  'Hardwood floors',
  'Fireplace',
  'Open concept',
  'Home office',
  'Finished basement',
  'Laundry',
  'Deck / patio',
  'Pool',
  'Garage',
];
